<script lang="ts">

    export let right: boolean = true;

</script>

<div class="client-marker">
    <lottie-player
        style="transform: scaleX({right ? 1 : -1});"
        src="/animations/mascot.json"
        autoplay
        loop></lottie-player>
</div>

<style lang="scss">

    $size: 60px;

    .client-marker {
        width: $size;
        height: $size;
        touch-action: none;
        pointer-events: none;
    } 

    lottie-player {
        width: 100%;
        height: 100%;
    }

</style>
